import type { InsertLinksHost } from 'owa-attachment-link-common';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';

export function getInsertLinksHost(composeViewState: ComposeViewState): InsertLinksHost {
    return {
        attachmentWell: {
            ...composeViewState.attachmentWell,
            logTraceId: composeViewState.logTraceId,
        },
        getRecipientWells: (): RecipientWellWithFindControlViewState[] => [
            composeViewState.toRecipientWell,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (16,13): Type 'RecipientWellWithFindControlViewState | null' is not assignable to type 'RecipientWellWithFindControlViewState'.
            // @ts-expect-error
            composeViewState.ccRecipientWell,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (20,13): Type 'RecipientWellWithFindControlViewState | null' is not assignable to type 'RecipientWellWithFindControlViewState'.
            // @ts-expect-error
            composeViewState.bccRecipientWell,
        ],
    };
}
